/**
 *  @class
 *  @function SlideShow
 */
if (!customElements.get('slide-show')) {
  class SlideShow extends HTMLElement {
    constructor() {
      super();

    }

    connectedCallback() {
      const slideshow = this;
      const slides = Array.from(slideshow.querySelectorAll('.carousel__slide'));
      const dots = slideshow.dataset.dots === 'true';
      const autoplay = slideshow.dataset.autoplay === 'false' ? false : parseInt(slideshow.dataset.autoplay, 10);
      const align = slideshow.dataset.align === 'center' ? 'center' : 'left';
      const fade = slideshow.dataset.fade === 'true';
      const prevButton = slideshow.querySelector('.flickity-prev');
      const nextButton = slideshow.querySelector('.flickity-next');
      const customDots = slideshow.querySelector('.flickity-page-dots');
      const rightToLeft = document.dir === 'rtl';
      const progress_bar = slideshow.parentNode.querySelector('.flickity-progress--bar');
      let selectedIndex = 0;
      const args = {
        wrapAround: false,
        cellAlign: align,
        pageDots: dots,
        contain: true,
        fade: fade,
        autoPlay: autoplay,
        rightToLeft: rightToLeft,
        prevNextButtons: false,
        cellSelector: '.carousel__slide',
        on: {}
      };

      if (slides.length < 1) return;
      const isMobile = window.innerWidth <= 767;
      
      if (slideshow.classList.contains('collection-grid--container')) {
        if (isMobile && slideshow.classList.contains('remove-mobile-slider')) {
          args.wrapAround = false;
           args.on.change = function (index) {
            const flkty = this;
             flkty.destroy();
           }
           args.on.ready = function () {
            const flkty = this;
             flkty.destroy();
           }
         }else{
          args.groupCells = false;
          args.wrapAround = true;
           args.on.ready = function () {
            const flkty = this;
            flkty.resize();
            // Custom Dots.
            if (dots && customDots) {
              const dots = customDots.querySelectorAll('li');
              dots.forEach((dot, i) => {
                dot.addEventListener('click', () => {
                  flkty.select(i);
                });
              });
              dots[this.selectedIndex].classList.add('is-selected');
            }
           }
           args.on.change = function (index) {
            const flkty = this;
            // Custom Dots.
              if (dots && customDots) {
                const dots = customDots.querySelectorAll('li');
                dots.forEach((dot, i) => {
                  dot.classList.remove('is-selected');
                });
                dots[this.selectedIndex].classList.add('is-selected');
              }
            }
         }
        if (progress_bar) {
          args.wrapAround = false;
          args.on.scroll = function (progress) {
            progress = Math.max(0, Math.min(1, progress));
            progress_bar.style.width = progress * 100 + '%';
          };
        }
         const maxHeight = this.getMaxHeight('.carousel__slide'); // Replace with your element's class
         slides.forEach((sld) => {
           sld.style.minHeight = maxHeight+"px";
         })
       }
      if (slideshow.classList.contains('collection-grid--container-wrapp')) {
        if (isMobile) {
          args.wrapAround = false;
        } else {
          args.groupCells = false;
          args.wrapAround = true;
        }
      }
      if (slideshow.classList.contains('popup-modal-slider')) {
         args.groupCells = false;
         args.wrapAround = true;
      }

      if (slideshow.classList.contains('collectionlist-slide')) {
         args.groupCells = false;
         args.wrapAround = true;
         args.cellAlign = 'center';
         args.on.ready = function () {
          const flkty = this;
          flkty.resize();
         }
         args.on.change = function (index) {
          const flkty = this;
        }
          if (progress_bar) {
            args.wrapAround = false;
            args.on.scroll = function (progress) {
              progress = Math.max(0, Math.min(1, progress));
              progress_bar.style.width = progress * 100 + '%';
            };
          }
           const maxHeight = this.getMaxHeight('.carousel__slide'); // Replace with your element's class
           slides.forEach((sld) => {
             sld.style.minHeight = maxHeight+"px";
           })
       }

      if (slideshow.classList.contains('collection-banner--product')) {
         args.groupCells = false;
         args.wrapAround = true;
         args.on.ready = function () {
          const flkty = this;
          flkty.resize();
          // Custom Dots.
          if (dots && customDots) {
            const dots = customDots.querySelectorAll('li');
            dots.forEach((dot, i) => {
              dot.addEventListener('click', () => {
                flkty.select(i);
              });
            });
            dots[this.selectedIndex].classList.add('is-selected');
          }
         }
         args.on.change = function (index) {
          const flkty = this;
          // Custom Dots.
            if (dots && customDots) {
              const dots = customDots.querySelectorAll('li');
              dots.forEach((dot, i) => {
                dot.classList.remove('is-selected');
              });
              dots[this.selectedIndex].classList.add('is-selected');
            }
          }
         if (progress_bar && isMobile) {
          args.wrapAround = false;
          args.on.scroll = function (progress) {
            progress = Math.max(0, Math.min(1, progress));
            progress_bar.style.width = progress * 100 + '%';
          };
        }
         const maxHeight = this.getMaxHeight('.carousel__slide'); // Replace with your element's class
         slides.forEach((sld) => {
           sld.style.minHeight = maxHeight+"px";
         })
      }
      
      if (slideshow.classList.contains('ssb-review-videoimg-slider')) {
        //args.asNavFor = '.ssb-review-carousel';
        args.draggable = false;
        args.wrapAround = true;
        const videoInner = slideshow.querySelectorAll('.ssb-review--videoinn');
        args.on.ready = function () {
          const flkty = this;
          if (videoInner) {
            videoInner.forEach((video, i) => {
              if(video.querySelector('video')) {
                video.querySelector('video').pause();
              }
            });
            if(videoInner[this.selectedIndex].querySelector('video')) {
              videoInner[this.selectedIndex].querySelector('video').play();
            }
          }
        }
      }
      if (slideshow.classList.contains('ssb-review-carousel')) {
         //args.asNavFor = '.ssb-review-videoimg-slider';
         args.groupCells = false;
         args.wrapAround = true;
        
         const videoSlider = document.querySelector('.ssb-review-videoimg-slider');
         const videoInner = videoSlider?.querySelectorAll('.ssb-review--videoinn');

         args.on.ready = function () {
          const flkty = this;
          flkty.resize();
          // Custom Dots.
          if (dots && customDots) {
            const dots = customDots.querySelectorAll('li');
            dots.forEach((dot, i) => {
              dot.addEventListener('click', () => {
                flkty.select(i);
              });
            });
            dots[this.selectedIndex].classList.add('is-selected');
          }
          if (videoInner?.[this.selectedIndex]?.querySelector('video')) {
            videoInner[this.selectedIndex].querySelector('video').play();
          }
         }
         args.on.change = function (index) {
          const flkty = this;
          // Custom Dots.
            if (dots && customDots) {
              const dots = customDots.querySelectorAll('li');
              dots.forEach((dot, i) => {
                dot.classList.remove('is-selected');
              });
              dots[this.selectedIndex].classList.add('is-selected');
            }
            if (videoInner) {
              videoInner.forEach(video => {
                const vid = video.querySelector('video');
                if (vid) vid.pause();
              });
              const currentVideo = videoInner[this.selectedIndex]?.querySelector('video');
              if (currentVideo) currentVideo.play();
              videoSlider.flkty.select( this.selectedIndex );
            }
          }
       }

      if (slideshow.classList.contains('instafeed-grid--container')) {
         args.wrapAround = true;
       }
     

      if (slideshow.classList.contains('main-slideshow')) {
        if (slideshow.classList.contains('desktop-height-image') || slideshow.classList.contains('mobile-height-image')) {
          args.adaptiveHeight = true;
        }

        args.on.ready = function () {
          const flkty = this;

          flkty.resize();

          // Custom Dots.
          if (dots && customDots) {
            const dots = customDots.querySelectorAll('li');
            dots.forEach((dot, i) => {
              dot.addEventListener('click', () => {
                flkty.select(i);
              });
            });
            dots[this.selectedIndex].classList.add('is-selected');
          }

          // Video Support.
          const videoContainer = flkty.cells[0].element.querySelector('.slideshow__slide-video-bg');
          if (videoContainer) {
            const iframe = videoContainer.querySelector('iframe');
            const video = videoContainer.querySelector('video');

            const loadVideo = () => {
              if (iframe && iframe.classList.contains('lazyload')) {
                iframe.addEventListener('lazybeforeunveil', () => {
                  slideshow.videoPlay(videoContainer);
                });
                lazySizes.loader.checkElems();
              } else if (video) {
                slideshow.videoPlay(videoContainer);
              }
            };

            if (iframe) {
              iframe.onload = loadVideo;
            } else if (video) {
              video.onloadstart = loadVideo;
            }
          }
        };

        args.on.change = function (index) {
          const flkty = this;
          const muteWrapper = slideshow.querySelector('.slideshow-video--btnmute');
          const muteButton = muteWrapper?.querySelector('.slideshow-btn-mute');
          if(muteButton?.classList.contains('play_audio')){
            muteButton.classList.remove('play_audio');
          }
          if(flkty.cells){
            flkty.cells.forEach(fcell => {
              if(fcell.element.querySelector('video')){
                fcell.element.querySelector('video').muted = true;
              }
            });
          }
          if(muteWrapper){
            if(flkty.cells[flkty.selectedIndex].element.classList.contains('video_show_slide')){
              muteWrapper.style.display = "block";
            }else{
              muteWrapper.style.display = "none";
            }
          }
          
          // Color changes.
          const colorText = getComputedStyle(this.selectedElement).getPropertyValue('--color-body');
          const dotsWrapper = slideshow.querySelector('.flickity-custom-navigation-wrapper');
          if (dotsWrapper) {
            dotsWrapper.style.setProperty('--color-body', colorText);
          }

          // Custom Dots.
          if (dots && customDots) {
            const dots = customDots.querySelectorAll('li');
            dots.forEach((dot, i) => {
              dot.classList.remove('is-selected');
            });
            dots[this.selectedIndex].classList.add('is-selected');
          }

          // AutoPlay
          if (autoplay) {
            flkty.stopPlayer();
            flkty.playPlayer();
          }

          // Video Support.
          const previousIndex = fizzyUIUtils.modulo(this.selectedIndex - 1, this.slides.length);

          const videoContainerPrev = flkty.cells[previousIndex].element.querySelector('.slideshow__slide-video-bg');
          if (videoContainerPrev) {
            slideshow.videoPause(videoContainerPrev);
          }

          const videoContainer = flkty.cells[index].element.querySelector('.slideshow__slide-video-bg');
          if (videoContainer) {
            slideshow.videoPlay(videoContainer);
          }
        };
      }
      this.flkty = new Flickity(slideshow, args);

      selectedIndex = this.flkty.selectedIndex;

      if (prevButton) {
        prevButton.addEventListener('click', () => {
          this.flkty.previous();
        });
        prevButton.addEventListener('keyup', () => {
          this.flkty.previous();
        });
        nextButton.addEventListener('click', () => {
          this.flkty.next();
        });
        nextButton.addEventListener('keyup', () => {
          this.flkty.next();
        });
      }

      if (Shopify.designMode) {
        slideshow.addEventListener('shopify:block:select', (event) => {
          const index = slides.indexOf(event.target);
          this.flkty.select(index);
        });
      }
    }

    videoPause(videoContainer) {
      setTimeout(() => {
        if (videoContainer.dataset.provider === 'hosted') {
          videoContainer.querySelector('video').pause();
        } else if (videoContainer.dataset.provider === 'youtube') {
          videoContainer.querySelector('iframe').contentWindow.postMessage(JSON.stringify({
            event: "command",
            func: "pauseVideo",
            args: ""
          }), "*");
        } else if (videoContainer.dataset.provider === 'vimeo') {
          videoContainer.querySelector('iframe').contentWindow.postMessage(JSON.stringify({
            method: "pause"
          }), "*");
        }
      }, 10);
    }

    videoPlay(videoContainer) {
      setTimeout(() => {
        if (videoContainer.dataset.provider === 'hosted') {
          videoContainer.querySelector('video').play();
        } else if (videoContainer.dataset.provider === 'youtube') {
          videoContainer.querySelector('iframe').contentWindow.postMessage(JSON.stringify({
            event: "command",
            func: "playVideo",
            args: ""
          }), "*");
        } else if (videoContainer.dataset.provider === 'vimeo') {
          videoContainer.querySelector('iframe').contentWindow.postMessage(JSON.stringify({
            method: "play"
          }), "*");
        }
      }, 10);
    }
    getMaxHeight(selector) {
      const elements = this.querySelectorAll(selector);
      const heights = Array.from(elements).map(el => el.offsetHeight);
      return Math.max(...heights);
    }
  }

  customElements.define('slide-show', SlideShow);
}
function FlicktyNavigate(button, direction) {
  let wrapper = button.closest(".theme-scroll-nav-wrapp");
  if (!wrapper) return;

  let targetButton = wrapper.querySelector(
    `.flickity-custom-navigation-wrapper .flickity-${direction}`
  );

  if (targetButton) {
    targetButton.click();
  }
}

document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll(".video-grid-wrapp video").forEach(video => {
      video.closest('.coll-video-card').addEventListener("mouseenter", function() {
        video.play();
      });
    
      video.closest('.coll-video-card').addEventListener("mouseleave", function() {
        video.pause();
      });
    });
    const videos = document.querySelectorAll(".ssb-review-inn:not(.ssb-review-inn-slider) video");
    // const activevideo = document.querySelector(".ssb-review-inn.ssb-review-inn-slider .ssb-videoimg-slide.carousel__slide.is-selected video");
    function checkVisibility() {
      // if(activevideo){
      //   const activerect = activevideo.getBoundingClientRect();
      //   const activeinView = activerect.top >= 0 && activerect.bottom <= window.innerHeight;
      //   if (activeinView) {
      //     activevideo.play();
      //   } else {
      //     activevideo.pause();
      //   }
      // }
      videos.forEach(video => {
        const rect = video.getBoundingClientRect();
        const inView = rect.top >= 0 && rect.bottom <= window.innerHeight;
        if (inView) {
          video.play();
        } else {
          video.pause();
        }
      });
    }
    // Run on page load and scroll
    window.addEventListener("scroll", checkVisibility);
    window.addEventListener("resize", checkVisibility);
    checkVisibility(); 
});
function toggleMute(button) {
  let playvideo = button.closest(".play-videobanner").querySelector("video");

  if (playvideo.muted) {
    button.classList.add('play_audio');
    playvideo.muted = false;
  } else {
    button.classList.remove('play_audio');
    playvideo.muted = true;
  }
}
function toggleMuteVideo(button) {
  let playvideo = button.closest(".ssb-videoimg-slide").querySelector("video");

  if (playvideo.muted) {
    button.classList.add('play_audio');
    playvideo.muted = false;
  } else {
    button.classList.remove('play_audio');
    playvideo.muted = true;
  }
}

function toggleMuteslide(slideshowbtn) {
  let slideshowvideo = slideshowbtn.closest('.main-slideshow')?.querySelector('.slideshow__slide.is-selected')?.querySelector("video");
  if (!slideshowvideo) return;
  if (slideshowvideo.muted) {
    slideshowbtn.classList.add('play_audio');
    slideshowvideo.muted = false;
  } else {
    slideshowbtn.classList.remove('play_audio');
    slideshowvideo.muted = true;
  }
}
